import { render, staticRenderFns } from "./productTab.vue?vue&type=template&id=7011752f&scoped=true&"
import script from "./productTab.vue?vue&type=script&lang=js&"
export * from "./productTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011752f",
  null
  
)

export default component.exports